module.exports = __webpack_public_path__ + "static/media/image14.18ff547a.png";